import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    column: {
        width: "100%"
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'start'
    },
    centeredRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    toggleButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 20
    },
    toggleButton: {
        width: "50%",
        marginBottom: 5
    },
    formControl: {
        marginLeft: 30,
        width: "100%"
    },
    searchFormControl: {
        width: "100%",
        margin: 10
    },
    sourceList: {
        height: "100%",
        padding: 20,
        border: "solid 1px",
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.primary.main
    },
    destinationList: {
        height: "100%",
        padding: 20,
        border: "dashed 1px",
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.primary.main
    },
    totalDuration: {
        paddingLeft: 10,
        ...theme.palette.text.secondary
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'start',
        fontWeight: "bold",
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.error.main,
        borderRadius: 5,
        padding: 10,
        margin: 5,
        marginLeft: 30,
        marginRight: 30,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;"
    },
    warningIcon: {
        height: 40,
        width: 40,
        color: theme.palette.common.white,
        marginRight: 10
    }
}));

export {useStyles};
